import { withInstall } from '../../../utils/with-install'
import ThreeLayer from './ThreeLayer.vue'

export const ElAmapLayerThree = withInstall(ThreeLayer)
export default ElAmapLayerThree
